import React from "react";
import RelatedDataTabs from "@/components/shared/RelatedDataTabs";

interface EntityContextPanelProps {
    entityType: string;
    entityId: string;
}

export const EntityContextPanel: React.FC<EntityContextPanelProps> = ({
    entityType,
    entityId,
}) => {
    if (!entityId || !entityType) return null;

    return (
        <div id="entity-context-panel" className="w-full mt-4">
            <RelatedDataTabs entityType={entityType} entityId={entityId} />
        </div>
    );
};

export default EntityContextPanel;
